import { useNavigate, useLocation } from 'react-router-dom';
import {
    MotifVerticalNavigation,
    MotifVerticalNavigationContent,
    MotifVerticalNavigationMenu,
    MotifVerticalNavigationMenuItem,
    MotifVerticalNavigationSubmenu,
    MotifVerticalNavigationFooter,
    MotifVerticalNavigationContextSwitcher,
    MotifIcon,
    MotifButton
} from '@ey-xd/motif-react';
import all_inbox from '../assets/media/images/all_inbox.png';

const SideBar = ({ props }) => {

    const location = useLocation();
    const navigate = useNavigate();

    const redirectSelectedRoute = (path) => {
        navigate(path);
    };

    return (
        <div>
            <MotifVerticalNavigation>
                <MotifVerticalNavigationContent>
                    <MotifVerticalNavigationMenu>
                        <MotifVerticalNavigationMenuItem
                            icon={<img src={all_inbox} alt="all_inbox" width={20} />}
                            label="Workspaces"
                            selected={location?.pathname.includes('workspaces')}
                            onClick={() => redirectSelectedRoute('/workspaces')}
                        >
                            Workspaces
                        </MotifVerticalNavigationMenuItem>
                    </MotifVerticalNavigationMenu>
                </MotifVerticalNavigationContent>
            </MotifVerticalNavigation>
        </div>
    )
}

export default SideBar;